import React from 'react'
import { connect } from 'react-redux'
import { func, bool } from 'prop-types'

import { toggleSharePanelOpen } from 'models/ui/actions'
import { getSharePanelOpen } from 'models/ui/selectors'
import { getSelectedComposition, getIsSaving } from 'models/compositions/selectors'
import SharePanel from 'components/designSidepanel/SharePanel'
import { compositionType } from 'models/propTypes'

const SharePanelContainer = ({ close, isOpen, composition, isSaving }) => {
    if (!isOpen) {
        return null
    }
    return <SharePanel close={close} composition={composition} isSaving={isSaving} />
}

SharePanelContainer.defaultProps = {
    composition: null,
}

SharePanelContainer.propTypes = {
    close: func.isRequired,
    isOpen: bool.isRequired,
    composition: compositionType,
    isSaving: bool.isRequired,
}

const mapStateToProps = (state) => ({
    isOpen: getSharePanelOpen(state),
    composition: getSelectedComposition(state),
    isSaving: getIsSaving(state),
})

const mapDispatchToProps = {
    close: toggleSharePanelOpen,
}

export default connect(mapStateToProps, mapDispatchToProps)(SharePanelContainer)
